export default __webpack_public_path__ + "static/media/services_construction_view.9dfee103.png";